// extracted by mini-css-extract-plugin
export var ol = "List-module--ol--N0DJO";
export var ul = "List-module--ul--yOmQ6";